import {
  exportLocation,
  GooglePlaceAutocompleteType,
  importLocation,
  LocationAutocompleteLegacy,
  LocationType,
} from '@sortlist-frontend/shared-components';

type LocationSelectProps = {
  value?: GooglePlaceAutocompleteType | null;
  error?: string;
  onChange: (location: GooglePlaceAutocompleteType) => void;
  placeholder: string;
  className?: string;
  lang?: string;
};

export const LocationSelect = (props: LocationSelectProps) => {
  const { value, onChange, placeholder, lang } = props;

  const handleChange = (newLocation?: LocationType) => {
    onChange(importLocation(newLocation as LocationType));
  };
  return (
    <LocationAutocompleteLegacy
      currentValue={value ? exportLocation(value) : undefined}
      onChange={(location) => handleChange(location as LocationType)}
      placeholder={placeholder}
      lang={lang}
      types={['address']}
    />
  );
};
